module.exports = __webpack_public_path__ + "img/55.2c0c10d6.jpg";